<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div
      class="form_title_wrapper d-flex justify-content-between align-items-center"
    >
      <h4>{{ $t("PLACEHOLDERS.showComment", { id: data.id || "" }) }}</h4>
      <v-btn @click="$router.go(-1)" style="color: #000">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Comment Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <h6 class="col-12 mb-3">{{ $t("PLACEHOLDERS.commentInfo") }}</h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commenter_name')"
            v-model="data.client.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commenter_phone')"
            v-model="data.client.mobile"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.status_trans"
            disabled
          />

          <div class="col-lg-4 col-12 my-5">
            <div class="input_wrapper top_label">
              <label class="form-label">{{ $t("PLACEHOLDERS.rating_stars") }}</label>
              <div class="rate_display">
                <v-rating
                  dir="ltr"
                  background-color="warning"
                  color="warning"
                  empty-icon="fal fa-star"
                  half-icon="fas fa-star-half-alt"
                  full-icon="fas fa-star"
                  :length="5"
                  :size="22"
                  :value="Number(data.rate) || 0"
                  readonly
                  dense
                />
                <strong class="rate_number">{{ data.rate || 0 }}</strong>
              </div>
            </div>
          </div>

          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.comment_text')"
            v-model="data.comment"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.comment_type')"
            v-model="data.type_trans"
            disabled
          />

          <!-- Conditional: Booking related -->
          <template v-if="data.type === 'booking'">
            <h6 class="col-12 mb-3 mt-4">
              {{ $t("PLACEHOLDERS.bookingRelated") }}
            </h6>

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PLACEHOLDERS.booking_number')"
              v-model="data.booking_number"
              disabled
            />
            <!-- <base-input
              col="4"
              type="text"
              :placeholder="$t('PLACEHOLDERS.booking_status')"
              v-model="data.booking_status"
              disabled
            /> -->
          </template>

          <!-- Conditional: Provider related -->
          <template v-if="data.type === 'provider'">
            <h6 class="col-12 mb-3 mt-4">
              {{ $t("PLACEHOLDERS.providerRelated") }}
            </h6>

            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.provider_name')"
              v-model="data.provider.name"
              disabled
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.provider_phone')"
              v-model="data.provider.mobile"
              disabled
            />
          </template>

          <!-- Images / Attachments -->
          <div class="col-12" v-if="data.images && data.images.length">
            <h6 class="mb-3">{{ $t("PLACEHOLDERS.attachments") }}</h6>
            <div class="row">
              <div
                v-for="(img, idx) in data.images"
                :key="idx"
                class="col-3 mb-3"
              >
                <img
                  :src="img.url || img"
                  :alt="`attachment ${idx + 1}`"
                  class="vehicle-image"
                  @click="showImageModal(img.url || img)"
                />
              </div>
            </div>
          </div>

          <!-- Created at -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model="data.created_at"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- End:: Comment Content -->
  </div>
</template>

<script>
export default {
  name: "ShowRate",
  data() {
    return {
      data: {
        id: null,
        client: { name: "", mobile: "" },
        comment: "",
        rate: 0,
        status_trans: "",
        status: "",
        type: "", // 'booking' | 'provider' | ...
        type_trans: "",
        booking_number: "",
        booking_status: "",
        provider: { name: "", mobile: "" },
        images: [],
        created_at: "",
      },
    };
  },

  methods: {
    async getDataToShow() {
      try {
        const res = await this.$axios.get(`rates/${this.$route.params.id}`);
        const r = res.data.data?.rating || res.data.data || {};

        // Determine type from ratable.type if present
        let determinedType = "";
        const ratableType = r.ratable?.type;
        if (ratableType) {
          const t = String(ratableType).toLowerCase();
          if (t === "booking") determinedType = "booking";
          else determinedType = "provider";
        } else if (r.type) {
          determinedType = r.type;
        }

        this.data = {
          id: r.id || this.$route.params.id,
          client: {
            name: r.client?.name || r.client?.full_name || "-",
            mobile: r.client?.mobile || "-",
          },
          comment: r.comment || r.description || "-",
          rate: Number(r.rate ?? r.rating ?? r.stars ?? 0) || 0,
          // API uses is_publish in the provided response
          status_trans:
            typeof r.is_publish !== "undefined"
              ? r.is_publish
                ? this.$t("PLACEHOLDERS.published")
                : this.$t("PLACEHOLDERS.unpublished")
              : r.status_trans || "-",
          status:
            typeof r.is_publish !== "undefined"
              ? r.is_publish
                ? "published"
                : "unpublished"
              : r.status || "",
          type: determinedType,
          type_trans:
            r.type_trans ||
            (determinedType ? this.$t(`PLACEHOLDERS.${determinedType}`) : "-"),
          // number field from response mapped to booking_number if booking context
          booking_number:
            r.booking?.booking_number || r.number || r.booking_number || "-",
          // booking_status: r.booking?.status_trans || "-",
          provider: {
            name:
              r.ratable?.provider_name ||
              r.ratable?.name ||
              r.provider?.name ||
              "-",
            mobile: r.ratable?.mobile || r.provider?.mobile || "-",
          },
          images: r.images || r.attachments || [],
          created_at: r.created_at || "-",
        };
      } catch (err) {
        console.error(err.response?.data?.message || err.message);
      }
    },

    showImageModal(imageUrl) {
      window.open(imageUrl, "_blank");
    },
  },

  created() {
    this.getDataToShow();
  },
};
</script>

<style scoped>
.vehicle-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.vehicle-image:hover {
  transform: scale(1.05);
}
.single_step_form_content_wrapper {
  padding: 20px;
}

.rate_display {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
}

.rate_number {
  font-size: 18px;
  color: #173157;
}
</style>
